import TableCell from "components/Table/Cell";
import TableCellText from "ds/components/Table/Row/CellText";
import Box from "ds/components/Box";

import { LaunchPadTrackUserProgress } from "../types";
import { LAUNCHPAD_TRACK_COLUMN_ID } from "../constants";

type LaunchPadTrackUsernameCellProps = {
  user: Pick<LaunchPadTrackUserProgress, "userLogin">;
};

const LaunchPadTrackUsernameCell = ({ user }: LaunchPadTrackUsernameCellProps) => (
  <TableCell id={LAUNCHPAD_TRACK_COLUMN_ID.USERNAME}>
    <Box align="center">
      <TableCellText>{user.userLogin}</TableCellText>
    </Box>
  </TableCell>
);

export default LaunchPadTrackUsernameCell;
